import { AnyAction } from 'redux'

export { default as actions } from './actions'

export enum SuggestionReasonTypes {
  REQUEST_SUGGESTION_REASONS = 'REQUEST_SUGGESTION_REASONS',
  UPDATE_SUGGESTION_REASONS = 'UPDATE_SUGGESTION_REASONS',
  FAIL_SUGGESTION_REASONS = 'FAIL_SUGGESTION_REASONS',
  NONE = '',
}

export interface SuggestionReason {
  value: string
  label: string
  icon: string
}

export interface SuggestionReasonState {
  reasons: SuggestionReason[]
  requested: boolean
}

const INITIAL_STATE: SuggestionReasonState = {
  reasons: [],
  requested: false,
}

const suggestionReasons = (
  state = INITIAL_STATE,
  action: AnyAction = {
    type: SuggestionReasonTypes.NONE,
    payload: [],
  },
) => {
  switch (action.type) {
    case SuggestionReasonTypes.REQUEST_SUGGESTION_REASONS:
      return {
        ...state,
        requested: true,
      }
    case SuggestionReasonTypes.FAIL_SUGGESTION_REASONS:
      return {
        ...state,
        requested: false,
      }
    case SuggestionReasonTypes.UPDATE_SUGGESTION_REASONS:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default suggestionReasons
